import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { NetworkCallService } from "../../core/services/network-call.service";
import * as actions from '../actions';
import { catchError, EMPTY, map, switchMap, of } from "rxjs";
import {IBusinessDetailsResponse, ILegalEntitiesBusinessesResponse} from "../models/shared.model";
import {mergeMap} from "rxjs/operators";
import {CheckOneLegalEntityExistsService} from "../../core/services/check-one-legal-entity-exists.service";
import {HttpParams} from "@angular/common/http";
import { ISetupStatusResponse } from "../../features/todos/models/setup-status.model";
import { EMPTY_GUID } from "../constants";

@Injectable()
export class SharedEffects {

  constructor(
    private actions$: Actions,
    private readonly networkCallService: NetworkCallService,
    private checkForOneLeService: CheckOneLegalEntityExistsService
  ){}

  getBusiness$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(actions.getBusiness),
      switchMap(action =>
        this.networkCallService.get<IBusinessDetailsResponse[]>(`Business/${action.businessId}/BusinessDetails`).pipe(
          mergeMap((data: IBusinessDetailsResponse[]) => {
            return [
              actions.getBusinessSuccess({ response: data })
            ];
          }),
          catchError(error =>
            of(actions.getBusinessFailure({ error }))
          )
        )
      )
    );
  });

  legalEntities$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.loadLegalEntities),
      switchMap(action => {
        let params = new HttpParams();
        params = params.append('noLoader', action.noLoader);

        return this.networkCallService
          .get<ILegalEntitiesBusinessesResponse[]>(`Business/Businesses?param=${action.param}`, { params: params })
          .pipe(
            map((response: any) => {
              if (response.length === 1) {
                this.checkForOneLeService.selectTheOneLE(response[0]);
              }
              return actions.loadLegalEntitiesSuccess({ response });
            }),
            catchError(error =>
              of(actions.loadLegalEntitiesFailure({ error }))
            )
          );
      })
    )
  );

    setupStatus$ = createEffect(() =>
      this.actions$.pipe(
        ofType(actions.loadSetupStatus),
        switchMap(action => {
          if (!this.isValidBusinessId(action.businessId)) {
            return EMPTY;
          }

          return this.networkCallService.get<ISetupStatusResponse>(`Business/${action.businessId}/SetupStatus`).pipe(
            map(response => {
              return actions.loadSetupStatusSuccess({ response });
            }),
            catchError(error => {
              return of(actions.loadSetupStatusFailure(error));
            })
          );
        })
      )
    );

  private isValidBusinessId(businessId: string | null | undefined): boolean {
    const id = businessId?.trim().toLowerCase();
    return !!id && id !== 'null' && id !== 'undefined' && id !== EMPTY_GUID;
  }
}
